import { IGetMultaJurosContasReceberNoContratoUseCase } from "../../../presentation/useCases/read/get_multa_juros_contas_receber_no_contrato_use_case";
import { ContratoMultaJuros } from "../../models/contrato_multa_juros";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetMultaJurosContasReceberNoContratoUseCase
 */

export class GetMultaJurosContasReceberNoContratoUseCase implements IGetMultaJurosContasReceberNoContratoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(idContaReceber: number): Promise<ContratoMultaJuros | null> {
    return this.repository.getMultaJurosContasReceber(idContaReceber);
  }
}
